import { forwardRef, useState } from 'react'
import { useSnackbar } from "notistack"
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import { CircularProgress, FormControl, Grid, TextField } from '@material-ui/core'
import { useEffect } from 'react'
import ControleAcessoService from "../../../services/ControleAcessoService"
import PesquisaPerfisManutencaoAcessos from './_pesquisaPerfisManutencaoAcessos'
import OrgaosJurisdicionadosUsuario from './_orgaosJurisdicionadosUsuario'
import { cpfCnpj } from "../../../functions"
import webconfig from "../../../webconfig.json"

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function ManutencaoPerfil({ tipoOperacao, modalUsuario, setModalUsuario, orgaoUsuarioLogado, setAtualizarConsulta }) {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [listaPerfis, setListaPerfis] = useState([])
  const [idOrgaoUsuarioLogado, setIdOrgaoUsuarioLogado] = useState(0)
  const [listaOrgaosJurisdicionados, setListaOrgaosJurisdicionados] = useState([])
  const [ehRegistroSolicitacaoGestor, setEhRegistroSolicitacaoGestor] = useState(false)

  const Salvar = () => {
    if (idOrgaoUsuarioLogado === undefined) {
      setIdOrgaoUsuarioLogado(0)
    }

    modalUsuario.obj.listaPerfis = listaPerfis
    modalUsuario.obj.listaOrgaosJurisdicionados = listaOrgaosJurisdicionados

    setLoading(true)
    ControleAcessoService.Salva(modalUsuario.obj, idOrgaoUsuarioLogado)
      .then(response => {
        setLoading(false)
        if (response.status === 200) {
          setListaPerfis([])
          setListaOrgaosJurisdicionados([])
          enqueueSnackbar(response.data, { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
          handleFecharRecibo()
          let dataAtual = new Date();
          setAtualizarConsulta(dataAtual.toString());
        }
        else {
          enqueueSnackbar('Não foi possível salvar o deferimento da solicitação. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
        }
      })
      .catch(error => {
        setLoading(false);
        if (error.response && error.response.data) {
          if (error.response.status === 422) {
            try {
              const validacao = JSON.parse(error.response.data.detail);
              let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): ";
              for (let i = 0; i < validacao.Validacoes.length; i++) {

                var itemValidado = validacao.Validacoes[i];
                for (var propriedadeValidada in itemValidado) {
                  mensagem += itemValidado[propriedadeValidada];
                }

                if ((i + 1) < validacao.Validacoes.length) {
                  mensagem += "; ";
                }
              }

              enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
            }
            catch (e) {
              if (error.response.data.detail) {
                enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
              }
            }
          }
          else if (error.response.status === 500) {
            enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
          }
          else {
            enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
          }
        }
        else {
          enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
        }
      })
  }

  const handleFecharRecibo = () => {
    setModalUsuario({
      open: false,
      obj: {}
    })

    if (!loading) {
      setModalUsuario({
        open: false,
        obj: {}
      })
    }
  }

  useEffect(() => {
    if (orgaoUsuarioLogado !== null &&
      orgaoUsuarioLogado !== undefined &&
      orgaoUsuarioLogado.id !== null &&
      orgaoUsuarioLogado.id !== undefined) {
      setIdOrgaoUsuarioLogado(orgaoUsuarioLogado.id)
    }
    else {
      setIdOrgaoUsuarioLogado(0)
    }

    if (modalUsuario.obj.listaPerfis) {
      setListaPerfis(modalUsuario.obj.listaPerfis)
    }

    if (modalUsuario.obj.listaOrgaosJurisdicionados) {
      setListaOrgaosJurisdicionados(modalUsuario.obj.listaOrgaosJurisdicionados)
    }

    if (modalUsuario && modalUsuario.obj && modalUsuario.obj.listaOrgaosJurisdicionados) {
      let _ehRegistroSolicitacaoGestor = false
      for (let indice = 0; indice < modalUsuario.obj.listaOrgaosJurisdicionados.length; indice++) {
        if (modalUsuario.obj.listaOrgaosJurisdicionados[indice].setorIdOrgaoJurisdicionado === idOrgaoUsuarioLogado &&
          modalUsuario.obj.listaOrgaosJurisdicionados[indice].ehRegistroSolicitacaoGestor === true)
          _ehRegistroSolicitacaoGestor = true
      }
      setEhRegistroSolicitacaoGestor(_ehRegistroSolicitacaoGestor)
    }
  }, [modalUsuario.open])

  return (
    <Dialog
      open={modalUsuario.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleFecharRecibo}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      id="dialog-padrao"
    >
      <DialogTitle id="alert-dialog-slide-title" className="txt-primario">Manutenção de Acesso</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FormControl variant="outlined">
              <TextField
                id="outlined-basic-ticket"
                variant="outlined"
                type="text"
                label="Nome"
                value={modalUsuario.obj?.nome}
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FormControl variant="outlined">
              <TextField
                id="outlined-basic-ticket"
                variant="outlined"
                type="text"
                label="CPF"
                value={modalUsuario.obj?.cpf && cpfCnpj(modalUsuario.obj?.cpf)}
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FormControl variant="outlined">
              <TextField
                id="outlined-basic-ticket"
                variant="outlined"
                type="text"
                label="E-mail"
                value={modalUsuario.obj?.email}
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <OrgaosJurisdicionadosUsuario
              tipoOperacao={tipoOperacao}
              orgaoUsuarioLogado={orgaoUsuarioLogado}
              listaOrgaosJurisdicionados={listaOrgaosJurisdicionados}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <PesquisaPerfisManutencaoAcessos
              value={listaPerfis}
              setValue={setListaPerfis}
              disabled={ehRegistroSolicitacaoGestor}
              idOrgao={idOrgaoUsuarioLogado}
            />
          </Grid>
          {ehRegistroSolicitacaoGestor && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <p style={{ color: 'red' }}>
                ATENÇÃO: ESTE USUÁRIO TEM ACESSO DO TIPO GESTOR, LIBERADO PELA SOLICITAÇÃO DE
                ACESSO DO GESTOR. DESSA FORMA, A MANUTENÇÃO DE ACESSO DESSE USUÁRIO SÓ É POSSÍVEL
                PELO SERVIÇO DE PUBLICAÇÃO DO TCE-GO.
              </p>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleFecharRecibo} className="bg-alternativo-4 txt-alternativo-3" disabled={loading}>Cancelar</Button>

        {!ehRegistroSolicitacaoGestor && (
          <Button className="bg-primario txt-branco btn-salvar-default" onClick={() => loading ? ('') : Salvar()}>
            {
              loading
                ?
                <CircularProgress size={22} />
                :
                'Salvar'
            }
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}